import { useMutation } from "@tanstack/react-query";
import { saveAtreemoMappings } from "../../api/bAtreemoApi";

export const useSaveAtreemoMappings = () => {
  return useMutation({
    mutationKey: ["save-atreemo-mappings"],
    mutationFn: (data) => saveAtreemoMappings(data),
    onError: (error) => {
      console.error("Atreemo mapping save error:", error.response || error);
    },
  });
};
